import { useMutation } from '@tanstack/react-query';
import { deleteApiToken } from '../requests';
import type { DeleteApiTokenRequestDto } from '../../model';
import type { RequestHandlerOptions } from '@/shared/api';

export function useDeleteApiToken(options: RequestHandlerOptions = {}) {
  const mutation = useMutation<void, Error, DeleteApiTokenRequestDto>({
    mutationFn: args => deleteApiToken(args, options),
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
